// Module
var code = `<breadcrumbs></breadcrumbs>
<section class="box">
  <sub-header header="'Post manual inward check'"></sub-header>

  <div class="alert alert--danger" ng-if="\$ctrl.isBrstnInvalid()">
    BRSTN is not configured to branch. Please check branch configuration.
  </div>

  <form name="\$ctrl.form">
    <table class="misc-transaction__table table table--generate-row-ids">
      <tbody>
      <tr ng-if="!\$ctrl.isPchcDirectClearingEnabled">
        <td></td>
        <td>Depository account</td>
        <td>
          <selectize
            required
            options="\$ctrl.accounts"
            config="\$ctrl.accountSelectConfig"
            ng-model="\$ctrl.input.depositoryAccountId"
            ng-change="\$ctrl.onAccountChange()">
          </selectize>
        </td>
      </tr>
      <tr ng-if="\$ctrl.isPchcDirectClearingEnabled">
        <td></td>
        <td>Branch</td>
        <td>
          <select
            required
            ng-model="\$ctrl.selectedBranch"
            ng-options="branch as branch.name for branch in \$ctrl.branches"
            ng-change="\$ctrl.onBranchChange()">
          </select>
        </td>
      </tr>
      <tr>
        <td></td>
        <td>BRSTN</td>
        <td>
          <input
            disabled
            required
            type="text"
            minlength="9"
            maxlength="9"
            ng-model="\$ctrl.input.brstn"/>
        </td>
      </tr>
      <tr>
        <td></td>
        <td>Account number</td>
        <td>
          <input
            ng-disabled="!\$ctrl.isPchcDirectClearingEnabled"
            required
            type="text"
            minlength="12"
            maxlength="12"
            ng-model="\$ctrl.input.accountNumber"/>
        </td>
      </tr>
      <tr>
        <td></td>
        <td>Check number</td>
        <td>
          <input
            required
            type="text"
            minlength="10"
            maxlength="10"
            ui-mask="9999999999"
            ng-model="\$ctrl.input.checkNumber"/>
        </td>
      </tr>
      <tr>
        <td></td>
        <td>Amount</td>
        <td>
          <cash ng-model="\$ctrl.input.amount"
            ng-required="true"></cash>
        </td>
      </tr>
      </tbody>
    </table>
    <div class="buttons">
      <button
        class="btn btn-warning"
        ng-click="\$ctrl.redirectBack()">
        Cancel
      </button>
      <button
        class="btn btn-danger"
        ng-click="\$ctrl.postCheck()"
        ng-disabled="\$ctrl.form.\$invalid">
        Post check
      </button>
    </div>
  </form>

</section>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/inventory/check/outgoing/post-outgoing-check/post-outgoing-check.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;